import getAllTableViewsContainingItemsForFolder from '../../utils/getAllTableViewsContainingItemsForFolder';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import getSelectedTableViewId from 'owa-mail-list-store/lib/utils/getSelectedTableViewId';
import TableOperations from 'owa-mail-list-table-operations';
import tombstoneOperations from 'owa-mail-list-tombstone';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Remove a table from the store
 * @param tableViewId the table view id
 * @param state RemoveTableFromStoreState used for removeTableFromStore action
 */
export default select({
    tableViews: function () { return listViewStore.tableViews; },
})(action('removeTableFromStore')(function removeTableFromStore(tableViewId, state) {
    var tableViews = state.tableViews;
    var tableView = tableViews.get(tableViewId);
    // the selected table view should not be removed at any time
    if (getSelectedTableViewId() == tableViewId) {
        throw new Error('removeTableFromStore should not remove the currently selected table.');
    }
    // remove all conversations in this table view
    // VSO - 15466 - [Perf] cleaning of a table should be done async , and optimize the amount of work it does
    TableOperations.clear(tableView, null /* skipRowsNewerThanTime*/);
    // remove the table view from store
    tableViews.delete(tableViewId);
    // If all tables for the folder have been removed, also clear the tombstone list for the folder
    if (getAllTableViewsContainingItemsForFolder(tableView.tableQuery.folderId, false /* shouldIncludeSearchTable */).length == 0) {
        tombstoneOperations.clearMapForFolder(tableView.serverFolderId);
    }
}));
//# sourceMappingURL=removeTableFromStore.js.map